/**
 * @file CardListing/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const DEFAULT_IMAGE_POSITION = "top";
export const IMAGE_POSITIONS = ["top", "left", "right"];
export const IMAGE_SIZE_SLOTS = ["(max-width: 640px) 90vw", "320px"];
